export const GET_TRANSFERS_BY_USERS = "GET_TRANSFERS_BY_USERS";
export const SET_TRANSFERS_BY_USERS_LIST = "SET_TRANSFERS_BY_USERS_LIST";
export const SET_TRANSFERS_IS_LOADING = "SET_TRANSFERS_IS_LOADING";
export const GET_TRANSFERS = "GET_TRANSFERS";
export const SET_TRANSFERS = "SET_TRANSFERS";
export const GET_TRANSFERS_DETAILS = "GET_TRANSFERS_DETAILS";
export const SET_TRANSFERS_DETAILS = "SET_TRANSFERS_DETAILS";

export const getTransfersByUsers = payload => {
  return { type: GET_TRANSFERS_BY_USERS, payload };
};

export const getTransfers = payload => {
  return { type: GET_TRANSFERS, payload };
};

export const getTransfersDetails = payload => {
  return { type: GET_TRANSFERS_DETAILS, payload };
};



// WEBPACK FOOTER //
// src/modules/presence/actions/transfers.js